import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '../assets/img/icon.jpeg'


const _hoisted_1 = { class: "fixed z-50 top-0 left-0 right-0 w-full h-[60px] bg-gray-800 text-white flex justify-between items-center px-[20px]" }
const _hoisted_2 = { class: "relative flex justify-center items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl mx-[10px] md:mx-[20px]" }, "IronSecur", -1)
const _hoisted_4 = { class: "coter z-40 translate-x-[-280px] side p-[20px] pr-[50px] duration-300 ease-in-out overflow-y-auto fixed top-[60px] bg-gray-700 flex flex-col bottom-0 left-0 w-[280px]" }
const _hoisted_5 = { class: "w-full flex flex-col justify-center items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "w-[100px] h-[100px] rounded-[50%] border"
}, null, -1)
const _hoisted_7 = { class: "uppercase pt-[5px] text-white font-bold" }
const _hoisted_8 = { class: "py-[15px] relative w-full" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h1", { class: "px-[10px]" }, "Dashboard", -1)
const _hoisted_10 = { class: "text-white font-bold relative w-full flex flex-col pt-[15px]" }
const _hoisted_11 = { class: "flex items-center w-full relative" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h1", { class: "px-[10px] cursor-pointer" }, "Manage article", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-angle-down hidden text-sm text-black m-[5px]" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-angle-right text-sm text-black m-[5px]" }, null, -1)
const _hoisted_15 = { class: "text-white font-bold relative w-full flex flex-col pt-[15px]" }
const _hoisted_16 = { class: "flex items-center w-full relative" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h1", { class: "px-[10px] cursor-pointer" }, "Manage News", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-angle-down hidden text-sm text-black m-[5px]" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-angle-right text-sm text-black m-[5px]" }, null, -1)
const _hoisted_20 = { class: "text-white font-bold relative w-full flex flex-col pt-[15px]" }
const _hoisted_21 = { class: "flex items-center w-full relative" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h1", { class: "px-[10px] cursor-pointer" }, "Mailing system", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-angle-down hidden text-sm text-black m-[5px]" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-angle-right text-sm text-black m-[5px]" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-file-excel font-bold text-xl text-black" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h1", { class: "px-[10px]" }, "Import Subscribers", -1)
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("h1", { class: "px-[10px]" }, "Profil", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h1", { class: "px-[10px]" }, "Register", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-users font-bold text-xl text-black" }, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("h1", { class: "px-[10px]" }, "User's liste", -1)
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]

import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import axios from 'axios';
import axiosInstance from '@/plugins/axios';

export default /*#__PURE__*/_defineComponent({
  __name: 'headerComponentAdmin',
  setup(__props) {

let isSuperUser = ref(false);

const router = useRouter()

function goToRegisterPage() {
    router.push('/Register')
}
function goToUsersPage() {
    router.push('/users')
}
function goToDashboardPage() {
    router.push('/dashboard')
}

function goToListeOfArticlePage() {
    router.push('/ListeOfArticle')
}
function goToAddAnArticlePage() {
    router.push('/AddAnArticle')
}

function goToListOfNewsPage() {
    router.push('/ListeOfNews')
}
function goToAddAnNewsPage() {
    router.push('/AddAnNews')
}

function goToListOfMailPage() {
    router.push('/ListOfMails')
}
function goToAddAnMailPage() {
    router.push('/AddAnMail')
}

function goToImportSubscribersPage() {
    router.push('/ImportSubscribers')
}


function goToProfilePage() {
    router.push('/Profile')
}

const list = ref<HTMLElement | null>(null);
const iconName = ref("menu"); 
onMounted(() => {
    list.value = document.querySelector(".coter");
});

const Menu = () => {
    if (list.value) {
        if (iconName.value === "menu") {
            iconName.value = 'close'; 
            list.value.classList.remove('translate-x-[-280px]');
            list.value.classList.add('translate-x-0');
        } else {
            iconName.value = 'menu';
            list.value.classList.add('translate-x-[-280px]');
            list.value.classList.remove('translate-x-0');
        }
    }
};
const logout = () => {
    localStorage.clear();
    router.push('/');
};

let user = ref({
});

const fetchUserProfile = async () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      return;
    }

    const response = await axiosInstance.get('/auth/users/me/', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    user.value = response.data;
    isSuperUser.value = response.data.is_staff;
  } catch (error) {
    console.error(error);
  }
};

onMounted(() => {
  fetchUserProfile();
});

return (_ctx: any,_cache: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_ion_icon, {
          name: "menu",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (Menu())),
          class: "text-3xl cursor-pointer font-bold"
        }),
        _hoisted_3
      ]),
      _createElementVNode("div", { class: "relative flex justify-center items-center" }, [
        _createElementVNode("button", {
          onClick: logout,
          class: "p-[10px] bg-cyan-500 rounded-[5px] cursor-pointer text-sm text-white uppercase"
        }, "Log out")
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("h1", _hoisted_7, _toDisplayString(_unref(user).firstname) + " " + _toDisplayString(_unref(user).lastname), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", {
          onClick: goToDashboardPage,
          class: "text-white font-bold cursor-pointer flex py-[15px] items-center"
        }, [
          _createVNode(_component_ion_icon, {
            name: "grid",
            class: "font-bold text-xl text-black"
          }),
          _hoisted_9
        ]),
        _createElementVNode("span", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_ion_icon, {
              name: "file-tray-full",
              class: "font-bold text-xl text-black"
            }),
            _hoisted_12,
            _hoisted_13,
            _hoisted_14
          ]),
          _createElementVNode("div", { class: "flex flex-col relative items-end w-full py-[10px]" }, [
            _createElementVNode("span", {
              onClick: goToListeOfArticlePage,
              class: "cursor-pointer"
            }, "List of articles"),
            _createElementVNode("span", {
              onClick: goToAddAnArticlePage,
              class: "my-[5px] cursor-pointer"
            }, "Add an article")
          ])
        ]),
        _createElementVNode("span", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_ion_icon, {
              name: "file-tray-full",
              class: "font-bold text-xl text-black"
            }),
            _hoisted_17,
            _hoisted_18,
            _hoisted_19
          ]),
          _createElementVNode("div", { class: "flex flex-col relative items-end w-full py-[10px]" }, [
            _createElementVNode("span", {
              onClick: goToListOfNewsPage,
              class: "cursor-pointer"
            }, "List of news"),
            _createElementVNode("span", {
              onClick: goToAddAnNewsPage,
              class: "my-[5px] cursor-pointer"
            }, "Add an news")
          ])
        ]),
        _createElementVNode("span", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_ion_icon, {
              name: "file-tray-full",
              class: "font-bold text-xl text-black"
            }),
            _hoisted_22,
            _hoisted_23,
            _hoisted_24
          ]),
          _createElementVNode("div", { class: "flex flex-col relative items-end w-full my-[10px]" }, [
            _createElementVNode("span", {
              onClick: goToListOfMailPage,
              class: "cursor-pointer"
            }, "List of mails"),
            _createElementVNode("span", {
              onClick: goToAddAnMailPage,
              class: "my-[5px] cursor-pointer"
            }, "send an mail")
          ])
        ]),
        _createElementVNode("span", {
          onClick: goToImportSubscribersPage,
          class: "text-white cursor-pointer font-bold flex my-[15px] items-center"
        }, _hoisted_27),
        _createElementVNode("span", {
          onClick: goToProfilePage,
          class: "text-white cursor-pointer font-bold flex my-[15px] items-center"
        }, [
          _createVNode(_component_ion_icon, {
            name: "person",
            class: "font-bold text-xl text-black"
          }),
          _hoisted_28
        ]),
        (_unref(isSuperUser))
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              onClick: goToRegisterPage,
              class: "text-white cursor-pointer font-bold flex my-[15px] items-center"
            }, [
              _createVNode(_component_ion_icon, {
                name: "bag-add",
                class: "font-bold text-xl text-black"
              }),
              _hoisted_29
            ]))
          : _createCommentVNode("", true),
        (_unref(isSuperUser))
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              onClick: goToUsersPage,
              class: "text-white cursor-pointer font-bold flex my-[15px] items-center"
            }, _hoisted_32))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})